import { index, pgTable, uniqueIndex, uuid } from "drizzle-orm/pg-core";
import { createInsertSchema } from "drizzle-zod";
import z from "zod";

import { clinicsTable } from "./clinicsSchema";
import { patientsTable } from "./patientsSchema";
import { customTimestamp } from "./utils/types";

export const clinicsPatientsTable = pgTable(
  "clinics_patients",
  {
    id: uuid("id").primaryKey().defaultRandom(),
    clinicId: uuid("clinic_id")
      .references(() => clinicsTable.id, { onDelete: "cascade" })
      .notNull(),
    patientId: uuid("patient_id")
      .references(() => patientsTable.id, { onDelete: "cascade" })
      .notNull(),
    createdAt: customTimestamp("created_at")
      .notNull()
      .$defaultFn(() => new Date().toISOString()),
    updatedAt: customTimestamp("updated_at")
      .notNull()
      .$defaultFn(() => new Date().toISOString())
      .$onUpdateFn(() => new Date().toISOString()),
  },
  table => [
    index("clinics_patients_clinic_id_index").on(table.clinicId),
    index("clinics_patients_patient_id_index").on(table.patientId),
    uniqueIndex("clinics_patients_clinic_id_patient_id_unique_index").on(
      table.clinicId,
      table.patientId,
    ),
  ],
);

export const insertClinicsPatientsSchema = createInsertSchema(
  clinicsPatientsTable,
  {
    clinicId: z.uuid().min(1),
    patientId: z.uuid().min(1),
  },
).omit({
  createdAt: true,
  updatedAt: true,
});

export type InsertClinicsPatientsType = z.infer<
  typeof insertClinicsPatientsSchema
>;
